// src/api/drivers.ts
import { apiClient } from './client';
import type { DriverSummary, Order, ApiResponse } from '../types';

export const driversAPI = {
  // Get driver's assigned orders
  async getDriverOrders(): Promise<ApiResponse<Order[]>> {
    try {
      const response = await apiClient.get<Order[]>('/orders/driver-orders/');
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response?.data?.detail || 'Failed to fetch driver orders',
        status: error.response?.status || 500,
      };
    }
  },

  // Get driver summary
  async getDriverSummary(): Promise<ApiResponse<DriverSummary>> {
    try {
      const response = await apiClient.get<DriverSummary>('/orders/driver-orders/summary/');
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response?.data?.detail || 'Failed to fetch driver summary',
        status: error.response?.status || 500,
      };
    }
  },

  // Mark order as delivered
  async markDelivered(orderId: number, cashReceived: number): Promise<ApiResponse<Order>> {
    try {
      const response = await apiClient.post(
        `/orders/driver-orders/${orderId}/mark_delivered/`,
        { cash_received: cashReceived }
      );
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response?.data?.detail || 'Failed to mark order as delivered',
        status: error.response?.status || 500,
      };
    }
  },
};